import * as React from 'react';
import PropTypes from "prop-types";

import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';

export class ProfesoresConsulta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apellidos: this.props.apellidos, nombres: this.props.nombres
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = event => {
    let name = event.target.name;
    let value = event.target.value;

    if (name == "apellidos") {
      this.setState({ apellidos: value });
    }
    else if (name == "nombres") {
      this.setState({ nombres: value });
    }
  }

  handleSubmit = event => {
    //console.log("submit");
    event.preventDefault();
    const { url, page, size } = this.props;
    const { apellidos, nombres } = this.state;
    //console.log("url = " + url + " page = " + page + " size = " + size + " apellidos = " + apellidos + " nombres = " + nombres);
    this.props.handle(url, page, size, apellidos, nombres);
  }

  render() {
    return (
      <div>
        <form name="consulta" onSubmit={this.handleSubmit}>
            <Row key={0} className="form-group">
              <Col md={1}>
                <label className=" control-label" htmlFor="unidad">Apellidos:</label>
              </Col>
              <Col md={5} className="w-100">
                <Input
                type="text"
                placeholder="Apellidos"
                name="apellidos"
                id="apellidos"
                defaultValue={this.state.apellidos}
                onChange={this.handleChange}
                maxLength={ 30 }
                >
                </Input>
              </Col>
            </Row>
          <Row key={1}>
            <Col md={1}>
              <label className=" control-label" htmlFor="programa">Nombres:</label>
            </Col>
            <Col md={5} className="w-100">
              <Input
                type="text"
                placeholder="Nombres"
                name="nombres"
                id="nombres"
                defaultValue={this.state.nombres}
                onChange={this.handleChange}
                maxLength={30}
              >
              </Input>
            </Col>
          </Row>
          <Row key={2}>
            <Col md={12}><Button type="submit">Buscar</Button></Col>
          </Row>
        </form>
      </div>
    );
  }
}

ProfesoresConsulta.propTypes = {
  apellidos: PropTypes.any,
  nombres: PropTypes.any,
  handle: PropTypes.func
};

